import { createContext, useContext } from 'react';

import { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';

import { SitterProfileVersionOptions, ViewerOptions } from '../constants';

export type SitterProfileVersion =
  (typeof SitterProfileVersionOptions)[keyof typeof SitterProfileVersionOptions];

export type Viewer = (typeof ViewerOptions)[keyof typeof ViewerOptions];

export type PetType = 'cat-only' | 'mixed';

export type ViewMode = {
  petType: PetType;
  viewer: Viewer;
};

export interface RevampProfileContextType {
  serviceType: string | undefined;
  setServiceType: (serviceType: string) => void;
  sitterData: EnhancedPersonSitterProfile;
  viewMode: ViewMode;
  pageTreatment: SitterProfileVersion;
  reviewsModalOpen: boolean;
  setReviewsModalOpen: (open: boolean) => void;
  contactUrl: string;
}

export const RevampProfileContext = createContext<RevampProfileContextType | undefined>(undefined);

export const useRevampProfileContext = (): RevampProfileContextType => {
  const context = useContext(RevampProfileContext);
  if (context === undefined) {
    throw new Error('useRevampProfileContext must be used within a RevampProfileProvider');
  }
  return context;
};
